<p [ngClass]="{'pro-tip': blockText.blocType && blockText.blocType === 'conseil'}">
    <span *ngIf="blockText.blocType && blockText.blocType === 'attention' " class="warning">ATTENTION : </span>
    <span [innerHtml]="blockText.text | safe:'html'"></span>
</p>
